import React, { useEffect, useState } from 'react'
import FormikLogin from '../../components/loginComponent/login'
import $ from 'jquery';
import { connect } from "react-redux";
function LoginView(props) {
    useEffect(() => {
        $('html').css('background-image', 'url(assets/img/loginpage.png)');
        $('html').css('background-size', 'cover');
        $('#loginView').css('background-image', 'url(assets/img/loginpage.png)');
        $('#loginView').css('background-size', 'cover');
        $('div').removeClass('main-panel');
        $('#sidebars').remove();
        $('.navigationMenu').remove();

    }, [])
    return (
        <div id="loginView">
            <FormikLogin {...props} />
        </div>
    )
}

const mapStateToProps = ({ loginReducer }) => {
    return {
        loginReducer,
    }
}
export default connect(mapStateToProps)(LoginView)
